import { render, staticRenderFns } from "./nuevoUsuario.vue?vue&type=template&id=76596e56&scoped=true"
import script from "./nuevoUsuario.vue?vue&type=script&lang=js"
export * from "./nuevoUsuario.vue?vue&type=script&lang=js"
import style0 from "./nuevoUsuario.vue?vue&type=style&index=0&id=76596e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76596e56",
  null
  
)

export default component.exports